import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';
import { Upload, FileText, Image, Film, Music } from 'lucide-react';
interface EvidenceModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (evidence: any) => void;
}
export function EvidenceModal({
  isOpen,
  onClose,
  onSave
}: EvidenceModalProps) {
  const [formData, setFormData] = useState({
    description: '',
    fileName: '',
    fileType: ''
  });
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setFormData({
        ...formData,
        fileName: file.name,
        fileType: file.type
      });
    }
  };
  const handleSubmit = () => {
    if (!formData.fileName) return;
    onSave(formData);
    onClose();
    setFormData({
      description: '',
      fileName: '',
      fileType: ''
    });
  };
  return <Modal isOpen={isOpen} onClose={onClose} title="Upload Evidence" footer={<div className="flex justify-end space-x-3" data-id="element-123">
          <Button variant="ghost" onClick={onClose} data-id="element-124">
            Cancel
          </Button>
          <Button onClick={handleSubmit} disabled={!formData.fileName} data-id="element-125">
            Save Evidence
          </Button>
        </div>} data-id="element-122">
      <div className="space-y-6" data-id="element-126">
        <div className="border-2 border-dashed border-gray-300 rounded-xl p-8 text-center hover:bg-gray-50 transition-colors relative" data-id="element-127">
          <input type="file" className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" onChange={handleFileChange} accept="image/*,video/*,audio/*,.pdf,.doc,.docx" data-id="element-128" />
          <div className="flex flex-col items-center pointer-events-none" data-id="element-129">
            {formData.fileName ? <>
                <FileText className="w-12 h-12 text-primary-purple mb-3" data-id="element-130" />
                <p className="font-medium text-gray-900" data-id="element-131">{formData.fileName}</p>
                <p className="text-sm text-gray-500 mt-1" data-id="element-132">
                  {formData.fileType}
                </p>
              </> : <>
                <Upload className="w-12 h-12 text-gray-400 mb-3" data-id="element-133" />
                <p className="font-medium text-gray-900" data-id="element-134">
                  Click to upload files
                </p>
                <p className="text-sm text-gray-500 mt-1" data-id="element-135">
                  Photos, videos, documents, or audio
                </p>
              </>}
          </div>
        </div>

        <Input multiline label="Description" placeholder="Describe what this evidence shows..." value={formData.description} onChange={e => setFormData({
        ...formData,
        description: e.target.value
      })} data-id="element-136" />

        <div className="bg-yellow-50 p-4 rounded-lg text-sm text-yellow-800" data-id="element-137">
          <strong data-id="element-138">Note:</strong> Files are simulated in this beta version. Only
          metadata is stored locally.
        </div>
      </div>
    </Modal>;
}